import { useCallback } from "react";
import { createSearchParams, useNavigate } from "react-router-dom";
import SEARCH_PARAMS from "../constants/searchParams";
import useKlasisRouting from "./klasisRouting";

const useKlasisSearchNavigator = () => {
    const navigate = useNavigate();
    const { klasisRoute } = useKlasisRouting();

    const klasisSearchNavigate = useCallback(
        (searchPhrase: string, pageNumber: number = 1): void => {
            const query = new URLSearchParams();
            query.append(SEARCH_PARAMS.searchPhrase, searchPhrase ?? '');
            query.append(SEARCH_PARAMS.page, pageNumber.toString());

            navigate({
                pathname: klasisRoute('global-search'),
                search: `?${createSearchParams(query)}`
            }, { replace: true });
        },
        [klasisRoute]
    );

    return {
        klasisSearchNavigate
    }
}

export default useKlasisSearchNavigator;